module.exports = __webpack_public_path__ + "static/media/face-calm.f1b46c9e.webp";